import apiConfig from "@apiConfig";
import { components } from "@apiSchema";
import http from "@core/fetch";
import { useData } from "@hooks/useData";
import { ID } from "@datassential/platform-ui-lib";

type Response = components["schemas"]["CommonDataModel"];

export interface LrCategory {
    id: ID;
    title: string;
}

interface HomeCommonData {
    lrCategories: LrCategory[];
}

const DEFAULT_DATA: HomeCommonData = {
    lrCategories: [],
};

const REQUEST_TYPE: keyof typeof apiConfig = 'get home common data';

async function getHomeCommonData(): Promise<HomeCommonData> {
    try {
        const response: Response = await http.get(REQUEST_TYPE);

        return {
            lrCategories: (response.lrCategories ?? []).map(item => ({
                id: (item.id ?? 0) as ID,
                title: item.name ?? '',
            })),
        };
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return DEFAULT_DATA;
    }
}

export function useHomeCommonData() {
    return useData(DEFAULT_DATA, getHomeCommonData);
}
